<template>
    <div class="content-section-breadcrumb">
        <template v-if="breadcrumbs">
            <span v-for="(breadcrumbItem, index) in breadcrumbs" :key="index">
                <span v-if="index !== 0">&#32;/&#32;</span>
                <a
                    :href="breadcrumbItem.url"
                    @click="handleBreadcrumbClick(breadcrumbItem)"
                    target="_blank"
                >{{ breadcrumbItem.text }}</a>
            </span>
        </template>
        <template v-else>
            <v-progress-linear
                v-if="isBusy"
                class="breadcrumb-linear-container"
                color="primary"
                buffer-value="0"
                stream
                reverse
            ></v-progress-linear>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        /**
         * @type {Array<ContentSectionBreadcrumbItemType>}
         */
        breadcrumbs: {
            type: Array,
            required: true,
            validator(value) {
                return value.every(item =>
                    typeof item.url === "string" &&
                    typeof item.text === "string"
                );
            }
        }
    },
    data() {
        return {
            isBusy: false
        };
    },
    methods: {
        handleBreadcrumbClick(breadcrumbItem) {
            this.$emit('breadcrumb-clicked', breadcrumbItem);
        },
    }
}
</script>

<style lang="css">
.content-section-breadcrumb a {
    text-decoration: underline;
}

.content-section-breadcrumb a:active, .content-section-breadcrumb a:focus {
    color: var(--v-anchor-base);
}

.breadcrumb-linear-container {
    max-width: 38px;
    display: inline-block;
    justify-content: left;
}
</style>